import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FieldMaskingService {
  ngxMaskPhoneNumber = '(000) 000-0000';

  maskedPhoneNumber(phoneNumber: any): any {
    let number = phoneNumber ? phoneNumber.toString().trim().match(/(\d{3})(\d{3})(\d{4})/) : '';
    if (number.length > 2) {
      number = `(${number[1]}) ${number[2]}-${number[3]}`;
    }

    return number;
  }

  /**
   * Custom method to conform a string to a given mask format
   * @param value - The input value that needs to be masked
   * @param mask - The mask pattern (e.g., '000-000' for a number with a dash)
   */
  conformToMask(value: string | string[], mask: string): string {
    let conformedValue = '';
    let maskIndex = 0;
    let valueIndex = 0;

    while (maskIndex < mask.length && valueIndex < value.length) {
      const maskChar = mask[maskIndex];
      const valueChar = value[valueIndex];

      if (maskChar === '0') {
        if (/\d/.test(valueChar)) {
          conformedValue += valueChar;
          valueIndex += 1;
        } else {
          return conformedValue; // Invalid character
        }
      } else {
        conformedValue += maskChar;
        if (maskChar === valueChar) {
          valueIndex += 1;
        }
      }

      maskIndex += 1;
    }

    return conformedValue;
  }
}
